<div>
  <ng-container
    *ngFor="
      let rowModel of rowModels;
      let i = index;
      let last = last;
      trackBy: trackByRowId
    "
  >
    <div class="d-flex flex-row align-items-center">
      <div
        *ngIf="last; else deleteRowBtn"
        class="btn btn-primary btn-lg btn-bare mdi mdi-plus-circle mr-2"
        ngbTooltip="Create filter"
        (click)="addNewFilterRow()"
        aria-label="Add New Filter"
      ></div>
      <ng-template #deleteRowBtn>
        <button
          #addRowBtn
          class="btn btn-lg btn-bare mdi mdi-delete mr-2"
          ngbTooltip="Delete filter"
          (click)="deleteFilterRow(i)"
          aria-label="Delete Filter Item"
        ></button>
      </ng-template>
      <hs-filter-editor-row
        [columnFilters]="columnFiltersAvailable"
        [rowModel]="rowModel"
        [isLast]="last"
        (rowModelChange)="updateRowModel($event, i)"
        (addNewFilterRow)="addNewFilterRow()"
      >
        <!-- Projected into the row's `columnTypeSlot`, between its column and operator selects.
             Rendered ONLY when the host grid opted in AND the column's comparison type is one the
             user owns (an AGGREGATE_INFO column, whose catalog type is a TEXT placeholder). Both
             conditions are required: `enableColumnTypeOverride` defaults to false, and `typeOverride`
             is populated exclusively by `getAggInfoAwareColumnFilterModels`, so for every other
             consumer of this editor there is no picker and no behaviour change. -->
        <hs-column-type-picker
          columnTypeSlot
          *ngIf="columnTypeOverrideFor(rowModel) as typeOverride"
          class="mr-2"
          [type]="typeOverride.type"
          (typeChange)="onColumnTypeChange(i, $event)"
        ></hs-column-type-picker>
      </hs-filter-editor-row>
    </div>
  </ng-container>
</div>
